import React from "react";
import { otp } from "../../assets";
import { Link } from "react-router-dom";

const ModalSent = ({ title, copy, email }) => {
  return (
    <div className="flex flex-col w-[90%] py-3">
      <div className="divide-y">
        <div className="mb-2">
          <div className="flex flex-row items-center">
            <div className="font-black text-black text-[17px] md:text-[24px]">
              {title} Sent
            </div>
          </div>
          <p className="text-[12px] md:text-[14px] font-thin text-gray-500 my-3">
            Please check your email at{" "}
            <span className="font-bold text-black">{email}</span> for
            instructions to {copy}
            . <br />
            <br />
            If you don't get the email soon, check your spam folder.
          </p>
        </div>

        <form className="flex flex-col justify-center space-y-3">
          <div className="flex flex-row mt-5 py-2">
            <Link
              to="/login"
              className="text-white py-2 px-2 bg-primary hover:bg-tertiary rounded-md w-full justify-center items-center flex flex-col"
            >
              <p className="font-base tracking-wider text-[14px] md:text-[16px]">
                Back to Login
              </p>
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ModalSent;
